'use client'

import { FC } from 'react'

import { CheckIcon, ErrorRoundIcon } from '@/components/icons'

import { ChipProps } from './types'

const Chip: FC<ChipProps> = ({
  className,
  text,
  iconRightClick,
  iconLeftClick,
  onClick,
  selected = false,
  disabled = false,
  ...props
}) => {
  return (
    <div
      onClick={(e) =>
        disabled
          ? e.preventDefault()
          : onClick && !selected
            ? onClick()
            : undefined
      }
      className={`
        flex w-fit h-fit justify-center items-center gap-2 px-2 py-1 rounded-[56px] border border-tertiary bg-tertiary
        ${!selected ? 'hover:bg-[#53f75375]' : 'bg-tertiary'}
        ${!selected && onClick ? 'cursor-pointer' : 'cursor-default'}
        ${className}
      `}
      {...props}
    >
      {selected ? (
        <CheckIcon
          className="fill-primary-900 w-[20px] min-w-[20px] h-[20px] min-h-[20px]"
          onClick={iconLeftClick && iconLeftClick}
        />
      ) : null}
      <p className="prose-body text-primary-900">{text}</p>
      {selected && iconRightClick ? (
        <ErrorRoundIcon
          className="fill-gray w-[18px] min-w-[18px] h-[18px] min-h-[18px] cursor-pointer"
          onClick={iconRightClick}
        />
      ) : null}
    </div>
  )
}

export default Chip
